const $inject = [
  '$http',
  '$q',
  '$filter',
  '$rootScope',
  'moment',
  'APP_CONFIG',
  'cartService',
  'settingsService',
  'ENUMS',
  'dateTimeService',
];

const flailService = function flailService(
  $http,
  $q,
  $filter,
  $rootScope,
  moment,
  APP_CONFIG,
  cartService,
  settingsService,
  ENUMS,
  dateTimeService
) {
  let service = {
    resultsMaster: { flail: [] },
    resultsMasterCopy: { flail: [] },
    results: { flail: [] },
    fareClasses: [],
    hasResults: false,
    errorMessage: null,
    currentFilter: undefined,
    activeTime: null,
    displayMessages: [],
    setActiveTime,
    init,
    start,
    getResults,
    getFareRules,
    prepData,
    addFilter,
    bulkAddFilters,
    removeFilter,
    setFilters,
    sort,
    itemAddedToCart,
    BulkRemoveFareClassFilter,
    checkFareFilters,
    orderClasses,
    removeOverlappingDateTimeRanges,
    getMinutesFromDuration,
  };

  const TIME_FORMAT = dateTimeService.getFormat(ENUMS.dateTimeFormats.TIME_LONG);

  function init() {
    service.resultsMaster = {};
    service.resultsMasterCopy = {};
    service.results = { flail: [] };
    service.fareClasses = [];
    service.hasResults = false;
    service.hasBackendError = false;
    service.errorMessage = [];
    service.currentFilter = undefined;
    service.activeTime = null;
    service.displayMessages = [];

    $rootScope.$on('cartService:rail:removed', service.checkFareFilters);
  }

  function start(searches) {
    service
      .getResults('Rail', searches)
      .then(() => {
        service.hasResults = true;
        service.resultsMaster = angular.copy(service.results);
        service.resultsMasterCopy = angular.copy(service.results);
      })
      .catch(() => {
        service.hasBackendError = true;
      });
  }

  function getResults(type, searches) {
    const search = searches.Rails[0];
    const returnSearch = searches.Rails[1];

    const apiUrl = APP_CONFIG.MOCK_DATA.active ? APP_CONFIG.MOCK_DATA[type] : `${APP_CONFIG.api.url}${type}/search`;
    const params = [];

    for (var i = 0; i < searches.Rails.length; i++) {
      params.push({
        SearchIdentifier: searches.Rails[i].Identifier,
        SearchDate: moment(searches.Rails[i].Date, 'YYYY-MM-DD[T]HH:mm:ss').format('YYYY-MM-DD[T]HH:mm:ss'),
        OriginLocationCode: searches.Rails[i].Origin.Code,
        DestinationLocationCode: searches.Rails[i].Destination.Code,
        PaxCount: searches.Rails[i].Passengers.length,
        OpenReturn: searches.Rails.length > 1 ? false : searches.Rails[i].OpenReturn,
        RailCardCode: searches.Rails[0].RailCardCode,
      });
    }

    let deferred = $q.defer();
    $http
      .post(apiUrl, params)
      .then((response) => {
        const data = response.data;
        service.displayMessages = data.DisplayMessages;
        const railResults = data.RailResults;
        railResults.forEach((rail, index) => {
          let orderedData = $filter('orderBy')(rail.Results, 'DepartureTime');
          service.results.flail[index] = prepData(orderedData);
          service.errorMessage.push(rail.Response);
        });

        deferred.resolve(true);
      })

      .catch(() => {
        deferred.reject();
      });

    return deferred.promise;
  }

  function getFareRules(type, sector, fare) {
    const deferred = $q.defer();

    if (fare.RemarksCollection) {
      const fareRuleData = () => {
        let text = '';
        if (type == 'Rail' && fare.Code != null && fare.Code.constructor === Array && fare.Code.length != 0 && fare.Class) {
          text = `Fare rules for ${fare.Code[0]} fares in ${fare.Class} class apply\n\n`;
        }

        _.forEach(fare.RemarksCollection, (obj) => {
          text = text + obj.Code + '\n' + obj.Value + '\n\n';
        });
        return text;
      };

      const fareRules = {
        Type: 'Text',
        Data: fareRuleData(),
      };

      deferred.resolve(fareRules);
    } else {
      const apiUrl = `${APP_CONFIG.api.url}${type}/FareRules`;

      const params = {
        carrierCode: sector.Carrier,
        railNumber: sector.RailNumber,
        departureCode: sector.OriginLocationCode,
        departureDate: sector.DepartureDateTime,
        destinationCode: sector.DestinationLocationCode,
        fareCode: fare.Code[0],
        searchIdentifier: sector.SearchIdentifier,
      };

      $http
        .get(apiUrl, { params: params })
        .then((response) => {
          const data = response.data;
          deferred.resolve(data);
        })

        .catch(() => {
          deferred.reject();
        });
    }

    return deferred.promise;
  }

  function prepData(data) {
    let availableFilters = {
      priceRange: {
        name: 'priceRange',
        label: 'Price',
        labelSuffix: `(${settingsService.settings.Currency.Code})`,
        isResultsFilter: true,
        settings: {
          type: 'range',
          reference: 'Price',
          filterName: 'flailPriceRangeFilter',
          defaultMax: 0,
          defaultMin: 0,
          maxValue: 0,
          minValue: 0,
          step: 1,
          translateFunc: function (value) {
            return $filter('currency')(value, '', 0);
          },
          isActive: function () {
            return this.minValue > this.defaultMin || this.maxValue < this.defaultMax;
          },
          clear: function () {
            this.minValue = this.defaultMin;
            this.maxValue = this.defaultMax;
          },
        },
      },
      departureTimeRange: {
        name: 'departureTimeRange',
        label: 'Departure Time',
        isResultsFilter: true,
        settings: {
          type: 'range',
          reference: 'Departure',
          filterName: 'flailTimeFilter',
          defaultMax: 1439,
          defaultMin: 0,
          maxValue: 1439,
          minValue: 0,
          step: 5,
          translateFunc: translateMinutesTime,
          isActive: function () {
            return this.minValue > this.defaultMin || this.maxValue < this.defaultMax;
          },
          clear: function () {
            this.minValue = this.defaultMin;
            this.maxValue = this.defaultMax;
          },
        },
      },
      arrivalTimeRange: {
        name: 'arrivalTimeRange',
        label: 'Arrival Time',
        isResultsFilter: true,
        settings: {
          type: 'range',
          reference: 'Arrival',
          filterName: 'flailTimeFilter',
          defaultMax: 1439,
          defaultMin: 0,
          maxValue: 1439,
          minValue: 0,
          step: 5,
          translateFunc: translateMinutesTime,
          isActive: function () {
            return this.minValue > this.defaultMin || this.maxValue < this.defaultMax;
          },
          clear: function () {
            this.minValue = this.defaultMin;
            this.maxValue = this.defaultMax;
          },
        },
      },
      provider: {
        label: 'Providers',
        filterName: 'anyInCollectionFilter',
        isResultsFilter: true,
        settings: {
          type: 'multiSelect',
          reference: 'Provider',
          selectedReference: 'value',
          options: [],
          selected: [],
          isActive: function () {
            return this.selected.length > 0;
          },
          clear: function () {
            this.selected = [];
          },
        },
      },
    };

    let obj = {
      searchResults: data,
      classes: [],
      activeFilters: {},
      filters: {
        options: availableFilters,
        layout: [['priceRange', 'departureTimeRange', 'arrivalTimeRange'], ['provider']],
      },
    };

    angular.forEach(data, (item) => {
      let fareClasses = item.FareClasses;
      item.TotalFares = 0;
      item.HasAdditionalFares = false;

      angular.forEach(item.Legs, (leg) => {
        if (leg.TrainName && leg.TrainName.toLowerCase().includes('acela')) {
          item.HasAcelaOption = true;
        }
      });

      angular.forEach(fareClasses, (fare, key) => {
        if (fare == null) {
          delete fareClasses[key];
        } else {
          fare.Class = key;
          fare.DisplayFare = _.omit(fare, 'AdditionalFares');
          fare.CheapestFare = fare.DisplayFare;

          fare.AdditionalFares = _.map(fare.AdditionalFares, (additionalFare) => {
            additionalFare.Class = key;
            return additionalFare;
          });

          fare.AdditionalFares.unshift(fare.DisplayFare);

          if (fare.AdditionalFares.length > 1) {
            item.HasAdditionalFares = true;
          }

          item.TotalFares += fare.AdditionalFares.length;
        }
      });

      obj.classes = obj.classes.concat(Object.keys(fareClasses));
      let priceFilterSettings = obj.filters.options.priceRange.settings;

      if (item.MaxRate > priceFilterSettings.maxValue) {
        priceFilterSettings.maxValue = item.MaxRate;
        priceFilterSettings.defaultMax = item.MaxRate;
      }

      item.TripDays = calculateDayChanges(item.DepartureDateTime, item.ArrivalDateTime);
    });

    availableFilters.provider.settings.options = getCarrierOptions(data);

    buildFareClasses(obj.classes);

    obj.classes = orderClasses(service.fareClasses);

    return obj;
  }

  function calculateDayChanges(departureDateTime, arrivalDateTime) {
    const depart = new Date(departureDateTime);
    const arrive = new Date(arrivalDateTime);
    if (isNaN(depart.getTime()) || isNaN(arrive.getTime())) return 0;

    const departDate = new Date(depart.getFullYear(), depart.getMonth(), depart.getDate());
    const arriveDate = new Date(arrive.getFullYear(), arrive.getMonth(), arrive.getDate());

    const diff = arriveDate.getTime() - departDate.getTime();
    return Math.floor(diff / (1000 * 60 * 60 * 24));
  }

  function buildFareClasses(classes) {
    service.fareClasses = service.fareClasses.concat(classes);
    service.fareClasses = _.uniq(service.fareClasses);
  }

  function bulkAddFilters(filters, target, index, fareClass) {
    _.forOwn(filters, (filter, key) => {
      service.results[target][index].activeFilters[key] = filter;
    });

    if (fareClass) {
      service.results[target][index].activeFilters.fareClass = fareClass;
    }

    service.setFilters(target, index);
  }

  function addFilter(filter, args, target, index) {
    service.results[target][index].activeFilters[filter] = args;
    service.setFilters(target, index);
  }

  function removeFilter(filter, target, index) {
    delete service.results[target][index].activeFilters[filter];
    service.setFilters(target, index);
  }

  function setFilters(target, index) {
    service.results[target][index].searchResults = _.clone(service.resultsMaster[target][index].searchResults);

    $filter('flailCleanFilter')(service.results, target, index, ['filtered', 'priceFiltered', 'noMatch']);

    Object.keys(service.results[target][index].activeFilters).forEach((filter) => {
      const args = service.results[target][index].activeFilters[filter];

      if (filter === 'flailTimeFilter') {
        $filter('flailTimeFilter')(service.results, args, target, index, 'DepartureTime');
      }

      if (filter === 'priceRange' && cartService.items.length === 0) {
        $filter('flailPriceRangeFilter')(service.results, args.settings, target, index);
      }

      if (filter === 'departureTimeRange') {
        const obj = {
          start: args.settings.minValue,
          end: args.settings.maxValue,
        };

        $filter('flailTimeFilter')(service.results, obj, target, index, 'DepartureTime');
      }

      if (filter === 'arrivalTimeRange') {
        const obj = {
          start: args.settings.minValue,
          end: args.settings.maxValue,
        };

        $filter('flailTimeFilter')(service.results, obj, target, index, 'ArrivalTime');
      }

      if (filter === 'matchingFares') {
        $filter('matchingFaresFilter')(service.results, args, target, index);
      }

      if (filter === 'fareClass' && service.results[target][index].itemInCart) {
        $filter('fareClassFilter')(service.results, args, target, index);
      }

      if (filter === 'provider') {
        $filter('flailProviderFilter')(service.results, args, target, index);
      }
    });
  }

  function sort(filterExpression, index) {
    if (service.currentFilter != filterExpression) {
      service.currentFilter = filterExpression;
      $filter('flailGenericFilter')(service.results, filterExpression, index);
    } else {
      service.currentFilter = undefined;
      $filter('flailGenericFilter')(service.results, 'DepartureTime', index);
    }
  }

  function translateMinutesTime(mins) {
    let hours = Math.floor(mins / 60);
    let minutes = mins % 60;

    if (hours === 24 && minutes === 0) {
      hours = 23;
      minutes = 59;
    }

    if (minutes < 10) {
      minutes = '0' + minutes;
    }

    return moment(`${hours}:${minutes}`, 'H:mm').format(TIME_FORMAT);
  }

  function itemAddedToCart(parentIndex, row, item, ignoreFareMatching) {
    angular.forEach(service.results.flail, (flail, flailIndex) => {
      if (flailIndex != parentIndex && cartService.items.length === 0) {
        // hide non-matching fares, unless specifically told not to
        if (!ignoreFareMatching) {
          addFilter('matchingFares', item.DisplayFare, 'flail', flailIndex);
        }
        removeFilter('priceRange', 'flail', flailIndex);
        flail.filters.options.priceRange.settings.maxValue = flail.filters.options.priceRange.settings.defaultMax;
        flail.filters.options.priceRange.settings.minValue = flail.filters.options.priceRange.settings.defaultMin;
      }

      if (!flail.itemInCart) {
        addFilter('fareClass', item.Class, 'flail', flailIndex);
      }
    });

    item.orderBy = parentIndex;
    item.parent = service.results.flail[parentIndex];
    item.row = row;
    service.results.flail[parentIndex].itemInCart = true;
    service.results.flail[parentIndex].currentRow = row;
    service.results.flail[parentIndex].currentItem = item;
    item.row.selected = true;
    item.addedToCart = true;
    item.type = 'rail';

    cartService.items.push(item);
  }

  function BulkRemoveFareClassFilter() {
    angular.forEach(service.results.flail, (flail, flailIndex) => {
      removeFilter('fareClass', 'flail', flailIndex);
      removeFilter('matchingFares', 'flail', flailIndex);
    });
  }

  function checkFareFilters() {
    if (cartService.items.length === 0) {
      BulkRemoveFareClassFilter();
    }
  }

  function orderClasses(classes) {
    const classesOrdered = [];

    settingsService.settings.FlightConfiguration.FareClasses.forEach((fareClass) => {
      const match = _.find(classes, (className) => {
        return fareClass.Name === className;
      });

      if (match) {
        classesOrdered.push(match);
      }
    });

    return classesOrdered;
  }

  // All overlapping DateTime ranges will be removed.
  function removeOverlappingDateTimeRanges(flailIndex) {
    if (
      service.results.flail.length === 1 ||
      service.results.flail[flailIndex] == null ||
      service.results.flail[flailIndex].currentRow == null
    )
      return;

    // These values are from the select cart item.
    const itemDepartureDateTime = moment(service.results.flail[flailIndex].currentRow.DepartureDateTime);
    const itemArrivalDateTime = moment(service.results.flail[flailIndex].currentRow.ArrivalDateTime);

    // If flailIndex is 0, then that means that the user added Trip1 to the cart.
    // If flailIndex is 1, then that means that the user added Trip2 to the cart.
    // We set index to be the opposite because we want to filter out results for the OTHER trip.
    const index = flailIndex === 0 ? 1 : 0;
    let flail = service.resultsMaster.flail;

    if (flailIndex === 0) {
      // Gets all results where Trip2's DepartureDateTime is at least 30 minutes ahead of Trip1's ArrivalDateTime.
      flail[index].searchResults = flail[index].searchResults.filter(
        (x) => getMinutesFromDuration(moment(x.DepartureDateTime), itemArrivalDateTime) >= 30
      );
    } else {
      // Gets all results where Trip1's ArrivalDateTime is at least 30 minutes before of Trip2's DepartureDateTime.
      flail[index].searchResults = flail[index].searchResults.filter(
        (x) => getMinutesFromDuration(itemDepartureDateTime, moment(x.ArrivalDateTime)) >= 30
      );
    }

    // Refresh the results list.
    if (!service.results.flail[index].itemInCart) service.addFilter('', '', 'flail', index);
  }

  // Returns the amount of minutes from DateTime1 - DateTime2. DateTime1 should be the most recent DateTime.
  function getMinutesFromDuration(dateTime1, dateTime2) {
    return moment.duration(dateTime1.diff(dateTime2)).asMinutes();
  }
  function setActiveTime(target) {
    service.activeTime = target;
  }

  function getCarrierOptions(results) {
    const uniqueResults = _.uniqBy(results, (item) => {
      return item.Carrier;
    });

    if (results.filter((x) => x.HasAcelaOption).length > 0) {
      uniqueResults.push({
        Carrier: 'AcelaFake',
        CarrierName: 'Acela',
      });
    }

    const orderedResults = _.orderBy(uniqueResults, (item) => {
      return item.CarrierName.toLowerCase();
    });

    return _.map(orderedResults, (item) => {
      return {
        value: item.Carrier,
        label: item.CarrierName,
        id: `Carrier-${item.Carrier}`,
      };
    });
  }

  return service;
};

flailService.$inject = $inject;

export default flailService;



// WEBPACK FOOTER //
// ./src/services/flailService.js